<!-- services page section  -->
<div class="sevices-herobanner">
  <div class="container">
    <div class="row service-banner-container">
      <div class="col-md-7 order-mobile-2">
        <h5 class="banner-title">
          Qualibar provides a breadth of services…
        </h5>
        <h6 class="banner-subtitle">
          <!-- Our Services -->
        </h6>
      </div>
      <div class="col-md-5 order-mobile-1 text-center">
        <img src="./assets/images/services/softwate-development.svg" alt="" class="banner-img">
      </div>
    </div>
  </div>
</div>

<!-- Browser testing  -->
<div class="service-odd" id="browsertesting">
  <div class="container">
    <div class="row service-container align-items-start">
      <div class="col-md-5 text-center">
        <img src="./assets/images/services/mandaadvice.svg" alt="" class="service-img pt-4 mt-4">
      </div>
      <div class="col-md-7">
        <h6 class="service-title">M&A Technology Advisory</h6>
        <p class="service-description">
          Qualibar provides deep technology due-diligence services for both corporate growth and M&A
          activities. Our proven experience in the field will bring clarity to your technology strategy.
        </p>
        <h6 class="service-subtitle mt-4">We specialize in:</h6>
        <ul class="key-services  row">
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-manda.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">IT Org Capability and Structure Alignment Analysis</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-manda.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Application Architecture Analysis</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-manda.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Budget Analysis</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-manda.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Platform Analysis</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-manda.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">SLA Analysis</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-manda.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Technology Stack Analysis</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-manda.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Documentation</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-manda.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Cloud and Data Center Analysis</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-manda.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Risk Analysis</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-manda.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">API Strategy</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-manda.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Onshore / Offshore Strategy</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-manda.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Mobile Strategy</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-manda.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Legacy Platform Strategy</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-manda.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">SDLC Analysis</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-manda.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Technical Debt Analysis</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-manda.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">QA and Automation Coverage</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-manda.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Security and Compliance</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-manda.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Business Continuity</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-manda.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Performance and Scalability</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-manda.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">Outsource Strategy</span>
            </div>
          </li>
          <li class="col-md-6">
            <div class="key-service-cont">
              <img src="./assets/images/services/icon-manda.svg" alt="" class="key-service_icon">
              <span class="key-service_tilte">CI/CD</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>

<!-- Mobile app testing  -->
<div class="service-even" id="mobiletesting">
  <div class="container">
    <div class="row service-container">
      <div class="col-md-7">
        <h6 class="service-title">Staff Augmentation</h6>
        <p class="service-description">
          We provide skilled technical and non-technical resources around the world. Our proprietary vetting process ensures that qualified candidates are provided to you to work under your supervision.
        </p>
      </div>
      <div class="col-md-5 text-center">
        <img src="./assets/images/services/staff-augumentation.svg" alt="" class="service-img">
      </div>
    </div>
  </div>
</div>
